// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ltxf","content":"RecentSearches_content__it8dw"};